module.exports = __webpack_public_path__ + "img/Accueil.f99d06fb.svg";